export default "/images/img_2.png?b7996d56e2d4941de84a39a7fb42f213";